module.exports = __webpack_public_path__ + "static/media/cog.3582a13b.svg";